import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    border-bottom: 1px solid ${theme.colors.ultraLightGray};
    padding-bottom: 0.75rem;
  `}
`;

export const Photo = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
`;

export const WihtoutPhoto = styled.div``;

export const AboutCollaborator = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const DescriptionCollaborator = styled.div`
  ${({ theme }) => css`
    margin-left: 0.5rem;
    width: 10rem;

    p {
      margin: 0;
      font-size: 0.875rem;
      color: ${theme.colors.black};
      font-weight: 600;
    }

    > span {
      display: block;
      font-size: 0.75rem;
      color: ${theme.colors.gray};

      &:last-child {
        font-size: 0.75rem;
      }
    }
  `}
`;

export const StatusInvite = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.primary};
    margin-left: 0.5rem;
    background-color: transparent;
    border: 0;

    span {
      font-size: 0.75rem;
    }

    > svg {
      margin-left: 0.5rem;
      width: 20px;
      height: 20px;
      fill: ${theme.colors.primary};
    }
  `}
`;

export const EditAccess = styled.button`
  ${({ theme }) => css`
    font-size: 0.75rem;
    color: ${theme.colors.black};
    font-style: italic;
    text-decoration: underline;
    background: transparent;
    border: 0;
  `}
`;
